module.exports = __webpack_public_path__ + "img/39.891164b4.png";